import PendingBadge from './PendingBadge'

export default PendingBadge
